import { Context, Data, Effect, Layer } from "effect"
import { init, type Gpu as GpuHandle } from "vgpu"

/** Raised when the browser has no usable WebGPU adapter/device. */
export class GpuUnavailable extends Data.TaggedError("GpuUnavailable")<{
  readonly cause: unknown
}> {}

/**
 * The single vgpu `Gpu` context as an Effect service.
 *
 * `init()` is acquired once per scope and `dispose()`d when the scope closes,
 * so HMR / unmount never leaks a GPUDevice.
 */
export class Gpu extends Context.Service<Gpu, GpuHandle>()("escobar/gpu/Gpu") {
  static readonly layer = Layer.effect(
    Gpu,
    Effect.acquireRelease(
      Effect.tryPromise({
        try: () => init({ powerPreference: "high-performance", label: "escobar" }),
        catch: (cause) => new GpuUnavailable({ cause }),
      }),
      (gpu) => Effect.sync(() => gpu.dispose()),
    ),
  )
}
